import { styled } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid';

export const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
        outline: 'none',
    },
    '.MuiDataGrid-cell:focus-within': {
        outline: 'none',
    },
    '.MuiDataGrid-columnHeader:focus': {
        outline: 'none',
    },
    '.MuiDataGrid-row': {
        cursor: 'pointer'
    },
    '.inactive-job': {
        background: '#beb6b636',
        color: '#beb6b6fc'
    }
}));
